import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Alert, ScrollView, View, Linking} from 'react-native';
import moment from 'moment';

/////////////////////// utils
import {markDailyChallengeCompleted} from 'src/Redux/reducers/dailyChallenges.reducer';
import {
  apiMarkDailyChallengeCompleted,
  apiMarkSocialCompleted,
  apiScheduleNextDayDailyChallengeNotification,
} from 'src/Utils/apiCalls';
import {addChallengeCoins} from 'src/Utils/huntFunctions';

import {updateDataAtPath} from 'src/Utils/fireUtils';

/////////////////////// components
import {BodyText, ContinueButton, ChallengeCard} from 'src/Modules/CommonView';
import Badges from '../Badges/Badges';
import {navigationRef} from 'src/Nav/navigationHelpers';
import {useUserInfo, useUserId} from '../Hooks/reduxHooks';
import DelayedLoad from '../Nav/DelayedLoad';
import {addLocationToGuide} from '../Local/localFunctions';
import {cloudFlareOptimizeImage} from '../Utils/helpers';

// single coin with fox in profile direction
const coinImage = {
  uri: cloudFlareOptimizeImage(
    'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648581485_original.png',
  ),
};
const checkmark = require('src/Images/Icons/checkmark.png');

const CommunityChallenges = () => {
  const lastSpinDate = useUserInfo('lastSpinDate');
  const userId = useUserId();
  const dailyChallenges =
    useSelector((state) => state.dailyChallenges?.challenges) || [];
  const sortedDailyChallenges = [...dailyChallenges]?.sort((a, b) => {
    return a?.challenge_medium < b?.challenge_medium;
  });

  const instagramFollow = useUserInfo('instagramFollow');
  // console.log({dailyChallenges});
  const firstVisit = useSelector((state) => state.firstVisit);

  const [canShowInstagram, setCanShowInstagram] = useState(true);
  // const [canShowFacebook, setCanShowFacebook] = useState(true);

  const dispatch = useDispatch();

  const checkSocialChallenges = () => {
    Linking?.canOpenURL('instagram://').then((supported) => {
      if (!supported) {
        setCanShowInstagram(false);
      } else {
        return console.log('instagram urls can be opened');
      }
    });

    Linking?.canOpenURL('fb://page/226773278094364/').then((supported) => {
      if (!supported) {
        // setCanShowFacebook(false);
      } else {
        return console.log('instagram urls can be opened');
      }
    });
  };
  useEffect(() => {
    checkSocialChallenges();
  }, []);

  const markDailyCompleted = async (challenge, photo_url, share_UUID) => {
    console.log({challenge});

    if (userId && !challenge?.completed) {
      const markedComplete = await apiMarkDailyChallengeCompleted(
        userId,
        challenge.scheduled_id,
        photo_url,
        share_UUID,
      );

      console.log({markedComplete});

      // return Alert.alert('hey', JSON.stringify(markedComplete));

      // failing the question
      if (!markedComplete?.photo_grade?.is_correct) {
        return markedComplete;
      } else {
        markedComplete.response === 'success' &&
          dispatch(
            markDailyChallengeCompleted({challenge, photo_url, share_UUID}),
          );
        markedComplete.response === 'success' &&
          addChallengeCoins(userId, challenge?.coin_value || 10);

        //getting new earned badges if neccassary

        if (
          dailyChallenges.every((chal) => {
            chal.completed || chal.challenge_id === challenge?.challenge_id;
          })
        ) {
          apiScheduleNextDayDailyChallengeNotification(userId);
        }
        return markedComplete;
      }
    }
  };

  const markSocialCompleted = async (challengeType, completion_value) => {
    if (userId) {
      const markedComplete = await apiMarkSocialCompleted(
        userId,
        challengeType,
      );
      markedComplete.response === 'success' &&
        addChallengeCoins(userId, completion_value);
      const path = `/users/${userId}/${challengeType}`;
      markedComplete.response === 'success' && updateDataAtPath(path, true);
    }
  };

  const handleChallengePress = async (challenge) => {
    if (!userId) {
      return navigationRef.navigate('LoginModal', {
        message: 'You must log in to do daily challenges',
      });
    }

    if (challenge?.challenge_medium == 'local_submit') {
      return addLocationToGuide();
    }

    navigationRef.navigate('PhotoVideoCamera', {
      feedbackUnits: 'Coins',
      feedbackPoints: 10,
      text: challenge?.task,
      onScore: async (data) => {
        console.log('scoring daily challenge');
        return await markDailyCompleted(
          challenge,
          data?.downloadURL,
          data?.shareUUID,
        );
      },
      onFailScore: (data) => {
        // return Alert.alert('You failed the challenge!');
        const {photo_grade = {}, lr_app_challenge_completion_id = 0} = data;
        const {
          feedback_title = 'Close but no Cigar!!!!',
          feedback_body = 'We were not able to detect the required elements in the image!',
        } = photo_grade;

        navigationRef.navigate('ConfirmModal', {
          handleConfirm: async () => {
            navigationRef.goBack(null);
            navigationRef.goBack(null);
            handleChallengePress(challenge);
          },
          confirmText: 'Try Again',
          cancelText: 'Report Issue',

          handleCancel: () => {
            navigationRef.goBack(null);
            navigationRef.goBack(null);
            // return Alert.alert(
            //   '' + lr_app_challenge_completion_id,
            //   JSON.stringify(photo_grade)
            // );
            navigationRef.navigate('QuestionFeedback', {
              challenge,
              lr_app_challenge_completion_id,
              type: 'daily_challenge',
              userId,
              challenged_by_user: 1,
            });
          },
          thirdOption: 'Cancel',
          handleThird: () => {
            navigationRef.goBack();
          },
          confirmColor: global?.color?.orange,
          cancelColor: global?.color?.blue,
          titleText: feedback_title,
          titleTextStyle: {},
          bodyTextStyle: {},
          titleBodyText: feedback_body,
          titleImage: require('src/Images/sadTrophy.png'),
        });
      },
      onCapture: (data) => {
        return console.log('Done!', {data});
      },
      onReport: () => {
        navigationRef.navigate('QuestionFeedback', {
          challenge,
          type: 'daily_challenge',
        });
      },
      photoUrl: challenge.photo_url,
      shareUUID: challenge.shareUUID,
      isVideo: challenge?.type === 'video',
    });
  };

  var unfinishedDailyChallengeCount = 0;

  return (
    <View style={{flex: 1, paddingTop: 5}}>
      <ScrollView
        style={{flex: 1}}
        contentContainerStyle={{alignItems: 'center', paddingBottom: 50}}>
        <BodyText text={'Daily Photo & Local Challenges'} header />
        <BodyText
          text={
            'Complete each day to spin the prize wheel! All challenges are instantly judged by us!'
          }
          textStyle={{marginTop: 5, marginBottom: 5}}
        />
        {!!dailyChallenges?.length &&
          sortedDailyChallenges?.map?.((challenge, index) => {
            !challenge?.completed && unfinishedDailyChallengeCount++;
            return (
              <ChallengeCard
                key={challenge.scheduled_id}
                testID={`challenge-${index}`}
                title={challenge.name}
                description={challenge.task}
                icon={challenge.completed ? checkmark : coinImage}
                iconText={challenge.coin_value}
                completed={challenge.completed}
                handlePress={() => handleChallengePress(challenge)}
              />
            );
          })}
        {
          <ContinueButton
            text={'Spin Prize Wheel'}
            width={200}
            handlePress={() => {
              const currentDate = moment().format('YYYY-MM-DD');
              console.log({
                unfinishedDailyChallengeCount,
                firstVisit,
                lastSpinDate,
              });
              if (!firstVisit.hasPressedPrizes) {
                navigationRef.navigate('PrizeWheelModal');
              } else if (unfinishedDailyChallengeCount > 1) {
                Alert.alert(
                  `Finish at least 3 of the 4 challenges to spin the wheel!`,
                );
              } else if (lastSpinDate == currentDate) {
                Alert.alert(
                  'You already spun the wheel today!',
                  'Come back tomorrow to finish your daily challenges! to get another spin.',
                );
              } else {
                navigationRef.navigate('PrizeWheelModal');
              }
            }}
          />
        }

        <BodyText
          text={'Social Challenges'}
          // containerStyle={{ marginTop: 20 }}
          header
        />
        <BodyText
          text={'Earn awesome physical prizes with a quick share!'}
          textStyle={{marginTop: 5, marginBottom: 5}}
        />
        <DelayedLoad>
          <Badges
            showOnlyType={'referral_member_bonus'}
            removeBottomPadding={true}
          />
        </DelayedLoad>
        {!!canShowInstagram && (
          <ChallengeCard
            key={-1}
            title={'Follow us on Instagram'}
            description={'Like our instagram page to get free foxcoins!'}
            icon={instagramFollow ? checkmark : coinImage}
            iconText={20}
            completed={instagramFollow ? true : false}
            handlePress={async () => {
              if (!userId) {
                return navigationRef.navigate('LoginModal', {
                  message: 'You must log in to do daily challenges',
                });
              }
              if (!instagramFollow) {
                await markSocialCompleted('instagramFollow', 20);
              }
              Linking?.openURL('instagram://user?username=letsroam');
            }}
          />
        )}

        <BodyText
          text={'Player Badges'}
          containerStyle={{marginTop: 20}}
          header
        />
        <BodyText
          text={'Complete These Badges For Even More Rewards and Perks!'}
          textStyle={{marginTop: 5, marginBottom: 5, textAlign: 'center'}}
        />

        <ContinueButton
          text={'See All Badges'}
          width={200}
          handlePress={() => {
            if (!userId) {
              navigationRef.navigate('BadgesInfoModal');
            } else {
              navigationRef.navigate('LoginModal', {
                message: 'You must log in to see your badges',
              });
            }
          }}
        />

        {!dailyChallenges?.length && !userId && (
          <BodyText text={'Log in now to access daily challenges.'} />
        )}
      </ScrollView>
    </View>
  );
};

export default CommunityChallenges;
